import {Text} from "@gs-ux-uitoolkit-react/text";
import React, {FormEvent, useState} from "react";
import {Input} from "@gs-ux-uitoolkit-react/input";
import {Button} from "@gs-ux-uitoolkit-react/button";
import {Form} from "@gs-ux-uitoolkit-react/form";
import {useSignInContext} from "../context/SignInContextProvider";
import {LoadingIcon} from "@gs-ux-uitoolkit-react/loading";

export function MfaVerificationForm() {

    const [mfaSecret, setMfaSecret] = useState<string>();
    const {attemptMfaVerification} = useSignInContext();
    const [busy, setBusy] = useState(false);
    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        if (!mfaSecret) {
            return;
        }
        event.preventDefault();
        try {
            setBusy(true);
            await attemptMfaVerification(mfaSecret);
            setBusy(false);
        } catch (e) {
            setBusy(false);
            setMfaSecret('');
        }
    };

    return (
        <div className="flex flex-col items-stretch gap-6 w-full">
            <Text typography="textTitle02" data-qa-comp="verify-code-title">Verify the code</Text>
            <Text typography="textBody02Regular">
                Check your 'Spam' or 'Unknown Senders' folder if the SMS code does not arrive shortly.
            </Text>
            <Form preventSubmit onSubmit={handleSubmit} className="flex flex-col gap-6 w-full">
                <Input
                    autoFocus
                    name="mfaSecret"
                    type="text"
                    size="md"
                    emphasis="regular"
                    label="Enter the code you received"
                    className="w-full"
                    value={mfaSecret}
                    disabled={busy}
                    onChange={({currentTarget: {value}}) => setMfaSecret(value)}
                    data-qa-comp="mfa-code-input"
                />
                <Button
                    className="w-full"
                    size="md"
                    appearance="highlight"
                    emphasis="bold"
                    type="submit"
                    disabled={busy}
                    data-qa-comp="submit-button"
                >
                    {!busy ? 'Submit' : <LoadingIcon size="sm"/>}
                </Button>
            </Form>
        </div>
    )
}